import { UsersCard, UserDialogManager } from '.';

import { UsersContextProvider } from '../model';

const UsersContainer = () => {
  return (
    <UsersContextProvider>
      <UsersCard />
      <UserDialogManager />
    </UsersContextProvider>
  );
};

export default UsersContainer;
